function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmpty = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100%",
  height: "100%",
  viewBox: "0 0 64 41",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlSpace: "preserve",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd"
  },
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1,0,0,1,0,1)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 32,
  cy: 33,
  rx: 32,
  ry: 7,
  style: {
    fill: "rgb(29,29,29)"
  }
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M55,12.76L44.854,1.258C44.367,0.474 43.656,0 42.907,0L21.093,0C20.344,0 19.633,0.474 19.146,1.257L9,12.761L9,22L55,22L55,12.76Z",
  style: {
    fill: "none",
    fillRule: "nonzero",
    stroke: "rgb(62,62,62)",
    strokeWidth: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.613,15.931C41.613,14.326 42.607,13.001 43.84,13L55,13L55,31.137C55,33.26 53.68,35 52.05,35L11.95,35C10.32,35 9,33.259 9,31.137L9,13L20.16,13C21.393,13 22.387,14.323 22.387,15.928L22.387,15.95C22.387,17.555 23.392,18.851 24.624,18.851L39.376,18.851C40.608,18.851 41.613,17.543 41.613,15.938L41.613,15.931Z",
  style: {
    fill: "rgb(36,36,36)",
    fillRule: "nonzero",
    stroke: "rgb(62,62,62)",
    strokeWidth: 1
  }
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty.d0313fce80ab876d228f31da8fe5e266.svg";